import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogSizes } from '../../../../../enums/mat-dialog-sizes.enum';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AvatarBlockModule } from '../../avatar-block/avatar-block.module';
import { ButtonSpacerDirective } from '../../directives/button.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ControlMessagesComponent } from '../../../../shared/control-messages/control-messages.component';
import { GrowlerService } from '../../../../shared/growler/growler.service';
import { validateRecursive } from '../../../../../directives/validators/validate-recursive';
import { HostListenerService } from '../../../../../services/host-listener.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FlexSpacerDirective } from '../../directives/flex-spacer.directive';

export interface ConfirmActionV2DialogInput
{
    title: string;
    confirmButton: string;
    secondaryButton?: string;
    cancelButton?: string;
    hideCancelButton?: boolean;
    content?: string;
    danger?: string;
    control?: {
        control: FormControl<boolean> | FormControl<{ [prop: string]: string }> | FormControl<{ [prop: string]: string } | null>;
        type: 'toggle' | 'select'; // TODO: add controls as needed
        label: string;
        options?: { [prop: string]: string }[];
    };
    titleIcon?: string;
    largeTitleIcon?: boolean;
}

export interface ConfirmActionV2DialogResult
{
    success: boolean;
    secondary?: boolean;
}

@UntilDestroy()
@Component({
    selector: 'app-confirmation-action-dialog',
    templateUrl: './confirm-action-dialog.component.html',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        NgIf,
        NgTemplateOutlet,
        MatSlideToggleModule,
        ReactiveFormsModule,
        ButtonSpacerDirective,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        NgForOf,
        ControlMessagesComponent,
        AvatarBlockModule,
        FlexSpacerDirective,
    ],
})
export class ConfirmActionV2DialogComponent implements OnInit
{
    static readonly width = MatDialogSizes.SM;

    confirmButtonLabel: string;
    formGroup: FormGroup;

    constructor(
            private _dialogRef: MatDialogRef<ConfirmActionV2DialogComponent>,
            private _host: HostListenerService,
            private _fb: FormBuilder,
            private _growler: GrowlerService,
            @Inject(MAT_DIALOG_DATA) public data: ConfirmActionV2DialogInput,
    ) {
        if (!this.data.title) {
            this.data.title = 'Please Confirm';
        }
    }

    ngOnInit() {
        if (this.data.control) {
            this.formGroup = this._fb.nonNullable.group({});
            this.formGroup.registerControl(this.data.control.type, this.data.control.control);
        }

        this.confirmButtonLabel = this.data.confirmButton;
        this._host.isMobileMode().pipe(untilDestroyed(this)).subscribe({
            next: (isMobileMode) => {
                if (isMobileMode) {
                    const label = this.data.confirmButton.split(',');
                    this.confirmButtonLabel = label[0];
                } else {
                    this.confirmButtonLabel = this.data.confirmButton;
                }
            },
        });
    }

    closeSecondary() {
        this._dialogRef.close(<ConfirmActionV2DialogResult>{success: true, secondary: true});
    }

    closeAndConfirm() {
        if (this.formGroup && this.formGroup.invalid) {
            validateRecursive(this.formGroup);
            this._growler.oops('Please double check required field');
            return;
        }

        this._dialogRef.close(<ConfirmActionV2DialogResult>{success: true});
    }

    closeAndCancel() {
        this._dialogRef.close(<ConfirmActionV2DialogResult>{success: false});
    }

    trackByValue(_: number, option: { [prop: string]: string }): string {
        return option['value'];
    }
}
